var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 6,
    fill: "#FDE8C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0026 10.8334V13.5M13.0026 16.1667H13.0093M19.6693 13.5C19.6693 17.1819 16.6845 20.1667 13.0026 20.1667C9.32071 20.1667 6.33594 17.1819 6.33594 13.5C6.33594 9.81814 9.32071 6.83337 13.0026 6.83337C16.6845 6.83337 19.6693 9.81814 19.6693 13.5Z",
    stroke: "#E1A632",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.e9bbb3c4b310d1462af108a4b31d991d.svg";
export { ForwardRef as ReactComponent };